import { render, staticRenderFns } from "./shapes-info.vue?vue&type=template&id=566dd69a&lang=pug&"
import script from "./shapes-info.vue?vue&type=script&lang=js&"
export * from "./shapes-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports